import req from "../http";

const resume = {
  // 取得 同意書最新版本
  getConsent(params) {
    return req("get", "/ResumeModule/personalstatement/newest", params);
  },

  // 儲存 同意書
  agreeConsent(params) {
    return req("post", "/ResumeModule/PersonalInformationStatementRecord", params);
  },

  // 查詢是否填寫過 同意書
  getConsentRecord(params) {
    return req("get", "/ResumeModule/PersonalInformationStatementRecord", params);
  },

  // 取得 履歷類型
  getResumeType(params) {
    return req("get", "/ResumeModule/ResumeTypes/Enable", params);
  },

  // 投遞履歷
  submitResume(params) {
    return req("post", "/ResumeModule/Resume/Submit", params);
  },

  // 履歷完程度
  getResumeCompleteness(resumeId) {
    return req("get", `/ResumeModule/Resume/Completeness/${resumeId}`);
  },

  // 履歷分派 查詢
  getAssignResume(params) {
    return req("post", "/ResumeModule/AssignResume/Search", params);
  },

  // 自動分派履歷
  postAutoAssign(params) {
    return req("post", "/ResumeModule/AssignResume/AutoAssign", params);
  },

  // 分派履歷給某個 HR人員
  postAssign(params) {
    return req("post", "/ResumeModule/AssignResume/Assign", params);
  },
};

export default resume;